const SUCCESS_STATUS = 200;

export const isPaymentSuccess = ({ data, status } = {}) =>
  status === SUCCESS_STATUS && (String(data?.success) === 'true' || String(data?.pending) === 'true');
